module.exports = __webpack_public_path__ + "img/lunbo01.8dde10ac.jpg";